import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { createAvatar } from "@dicebear/avatars";
import * as style from "@dicebear/avatars-initials-sprites";
import { AiOutlinePhone, AiOutlineUser } from "react-icons/ai";
import { Oval } from "react-loader-spinner";
import { doc, setDoc } from "firebase/firestore";
import { db } from "config/firebaseConfig";

const Profile = () => {
  const { user } = useAuth();
  const [picture, setPicture] = useState(null);
  const [profile, setProfile] = useState(user);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    await setDoc(doc(db, `users/${user.email}`), profile).then((res) => {
      setLoading(false);
      setSuccess(true);
    });
  };

  useEffect(() => {
    if (user && !user?.image) {
      const svg = createAvatar(style, {
        seed: user.name ? user.name : "New",
        dataUri: true,
        // ... and other options
      });
      setPicture(svg);
    }
  }, [user]);
  return (
    <div className="w-full h-full flex flex-col  items-center justify-center">
      <div className=" h-full max-w-[700px] w-full  bg-header/40 rounded-lg  flex flex-col items-center shadow-lg space-y-3">
        <img
          src={picture}
          className="w-16 h-16 rounded-full border-gray-400/40 shadow-xl mt-10 border-4"
          alt={"User"}
        />
        <div className="py-5 text-xl">
          <span>{profile.email}</span>
        </div>

        <div className="relative flex  bg-gray-800  rounded-lg h-10   overflow-hidden">
          <div className="bg-gray-500/80 px-3 flex justify-center items-center">
            <AiOutlineUser className="w-5 h-5  " />
          </div>
          <input
            placeholder="Name"
            type={"text"}
            value={profile.name}
            onChange={(e) => {
              setProfile({ ...profile, name: e.target.value });
            }}
            className=" bg-transparent focus:border rounded-r-lg outline-dashed focus:border-primary  outline-none px-2  w-full "
          />
        </div>
        <div className="relative flex  bg-gray-800  rounded-lg h-10   overflow-hidden">
          <div className="bg-gray-500/80 px-3 flex justify-center items-center">
            <AiOutlinePhone className="w-5 h-5  " />
          </div>
          <input
            placeholder="Phone"
            type={"tel"}
            value={profile.phone}
            onChange={(e) => {
              setProfile({ ...profile, phone: e.target.value });
            }}
            className=" bg-transparent focus:border rounded-r-lg outline-dashed focus:border-primary  outline-none px-2  w-full "
          />
        </div>

        <div className="flex justify-between items-center">
          <button
            className="bg-blue-500 h-10 text-slate-300 w-fit px-10 rounded-lg hover:bg-blue-700 transition-all duration-300 ease-out"
            onClick={handleSave}
          >
            Save
          </button>
          {loading && (
            <Oval
              height={40}
              width={40}
              color="royalblue"
              secondaryColor="white"
            />
          )}
        </div>
        {success && <h1>Success,changes will take effect next login</h1>}
      </div>
    </div>
  );
};

export default Profile;
